<template>
  <div class="form-group">
    <h3>{{ tableName }}</h3>
  </div>
</template>

<script>
export default {
  props: {
    tableName: 'FFBA Options'
  }
}
</script>